<template>
  <div class="users-wrapper" v-if="ready">
    <div
      class="users-card-wrapper"
      v-for="info in data.results"
      :key="info.id"
      @click="handleUserPage(info.username)"
    >
      <div
        v-if="info.photos.length >= 1"
        class="bg-img"
        :class="info.photos.length == 3 ? 'first' : ''"
        v-bind:style="{
          backgroundImage: 'url(' + info.photos[0].urls.small + ')',
        }"
      ></div>
      <div
        v-if="info.photos.length >= 2"
        class="bg-img secound"
        v-bind:style="{
          backgroundImage: 'url(' + info.photos[1].urls.small + ')',
        }"
      ></div>
      <div
        v-if="info.photos.length >= 3"
        class="bg-img third"
        v-bind:style="{
          backgroundImage: 'url(' + info.photos[2].urls.small + ')',
        }"
      ></div>
      <div class="info">
        <div class="info-header">
          <vs-avatar
            size="65"
            history
            history-gradient
            @click="handleUserPage(info.username)"
          >
            <img :src="info.profile_image.medium" alt="profile img" />
          </vs-avatar>
          <div class="info-name" @click="handleUserPage(info.username)">
            {{ info.first_name }} {{ info.last_name }}
          </div>
        </div>
        <div class="main-info"></div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "Search Users",
    props: {
      /* data: {
        type: Array,
        required: true,
        default() {
          return [];
        },
      }, */
    },
    data() {
      return {
        currSearchType: this.$route.name,
        page: 1,
        data: [],
        ready: false,
      };
    },
    methods: {
      handleUserPage(username) {
        this.$router.push(`/user/${username}`);
      },
    },
    created() {
      console.log(this.data);
    },
    computed: {
      values() {
        return this.data;
      },
    },
  };
</script>

<style lang="scss" scoped>
  .users-wrapper {
    width: 100%;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;

    .users-card-wrapper {
      width: 416px;
      height: 254px;
      background-color: white;
      border-radius: 5px;
      box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1),
        0 1px 2px 0 rgba(0, 0, 0, 0.06);
      margin-right: 10px;
      margin-bottom: 10px;
      position: relative;
      cursor: pointer;

      .bg-img {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        border-radius: 5px;
        background-size: cover;
        background-repeat: no-repeat;
        filter: blur(1px);
      }
      .first {
        clip-path: polygon(0 0%, 0% 70%, 70% 0);
        z-index: 2;
      }
      .secound {
        z-index: 0;
      }
      .third {
        z-index: 1;
        clip-path: polygon(100% 100%, 30% 100%, 100% 30%);
      }
    }
    .info {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: 10;
      background-color: rgb(0, 0, 0);
      background-color: rgba(0, 0, 0, 0.4);

      .info-header {
        display: flex;
        flex-direction: row;
        align-items: center;
        width: 100%;
        margin: 2rem;

        .info-name {
          color: white;
          font-weight: 400;
          font-size: 1.2em;
          margin-left: 20px;
          overflow: hidden;
        }
      }
    }
  }
</style>
